import { useQuery } from "@apollo/client";

import { GET_FORM_VALIDATION_SUGGESTS } from "graphqlQueries/suggests";

export default function useAppSuggests() {
  const { loading } = useQuery(GET_FORM_VALIDATION_SUGGESTS);

  return { loading };
}
